function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill: #CCA606;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill: #F9C900;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill: #D8E1E7;}\r\n\t.st4{fill:#E2ECF1;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 123.5,
  cy: 274.66,
  r: 123.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M123.5,161.39c55.28,0,100.1,34.66,100.1,77.4c0,42.74-44.82,77.4-100.1,77.4 c-55.27,0-100.1-34.66-100.1-77.4C23.4,196.05,68.23,161.39,123.5,161.39z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M103.75,125.15c13.15,0,26.3,0,39.45,0c0,9.2,0,18.4,0,27.61c-6.27,9.15-32.59,8.28-39.45,0 C103.75,143.56,103.75,134.36,103.75,125.15z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M123.48,121.23c10.89,0,19.72,1.76,19.72,3.92c0,2.17-8.83,3.93-19.72,3.93c-10.9,0-19.73-1.76-19.73-3.93 C103.75,122.99,112.59,121.23,123.48,121.23z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M119.85,123.58l0.02-112.68l7.08-8.32c0,74.12,0,46.88,0,121C126.18,126.55,121.06,126.41,119.85,123.58z"
});

var SvgOrnament = function SvgOrnament(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    className: "ornament-svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 247 530.64",
    style: {
      enableBackground: "new 0 0 247 530.64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref3, _ref4, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.3287,
    y1: 142.2305,
    x2: 103.6235,
    y2: 142.2305
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#839CA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8E1E7"
    }
  })), _ref5, _ref6, _ref7)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrnament, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ornament.75a1a35c.svg";
export { ForwardRef as ReactComponent };